import React, { useEffect, useState } from "react";
import * as admin from 'firebase-admin';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    TextField, 
    DialogActions, 
    Button 
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";

import { SnackBarProp } from "./SimpleSnackBar";
import { useSelector } from "react-redux";
import { AppState } from "../reducers";
import { LoadableAccountData } from "../reducers/accounts";
import { updatePassword } from "../api";
// import ButtonWithLoading from "./ButtonWithLoading";

type UserRecord = admin.auth.UserRecord;

interface ResetPasswordDialogProps {
    onClose: () => void,
    isOpen: boolean,
    uid: string,
    snackBar: SnackBarProp,
    setSnackbar: (props: SnackBarProp) => void,
}

export default function ResetPasswordDialog(props: ResetPasswordDialogProps) {

    const {t} = useTranslation();

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const [password, setPassword] = useState<string>();

    const [password2, setPassword2] = useState<string>();

    const accounts = useSelector<AppState, LoadableAccountData>(state => state.accounts);

    const [account, setAccount] = useState<UserRecord>();

    useEffect(() => {
        if (accounts.kind === "loaded") {
            setAccount(accounts.data.find(x => x.uid === props.uid));
        }
    }, [props.uid])

    const submitButtonClicked = async () => {
        setIsSubmitting(true);
        if (password === password2) {
            try {
                if (account !== undefined && password !== undefined) {
                    console.log(account)
                    const response = await updatePassword({
                        uid: account.uid,
                        password: password,
                    })
                    setIsSubmitting(false);
                    props.onClose();
                }
            } catch (e: any) {
                console.log(e);
                setIsSubmitting(false);
                props.setSnackbar({
                    ...props.snackBar,
                    open: true,
                    message: e.message,
                    variant: "warning",
                });
            }
        } else {
            props.setSnackbar({
                ...props.snackBar,
                open: true,
                message: t("error.pw_confirm_not_match"),
                variant: "warning",
            });
            setIsSubmitting(false);
        }
    }

    const handlePasswordChange = () => (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    }

    const handlePassword2Change = () => (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword2(event.target.value);
    }

    return (
        <Dialog onClose={props.onClose} aria-labelledby="simple-dialog-title" open={props.isOpen}>
            <DialogTitle id="simple-dialog-title">{t("resetPasswordDialog.title")}</DialogTitle>
            <DialogContent>
                <TextField
                    required
                    id="password"
                    label={t("acc_key.pw_new")}
                    type="password"
                    onChange={handlePasswordChange()}
                    margin="normal"
                    fullWidth
                />
                <TextField
                    required
                    id="password2"
                    label={t("acc_key.pw_new_confirm")}
                    type="password"
                    onChange={handlePassword2Change()}
                    margin="normal"
                    fullWidth
                    onKeyUp={(e) => {
                        if (e.key === "Enter") {
                            submitButtonClicked()
                        }
                    }}  
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} color="primary">{t("butt.cancel")}</Button>
                {/* <ButtonWithLoading onClick={submitButtonClicked} color="primary" isLoading={isSubmitting}>儲存</ButtonWithLoading> */}
                <LoadingButton loading={isSubmitting} color="primary" onClick={submitButtonClicked} variant="contained">
                    {t("butt.save")}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}